<app-test>
    @if(activeQuestion) {
    <ng-container slot="progress">
        <div class="bg-background-dark w-full rounded-xl shadow-sm overflow-hidden mr-8">
            <div class="relative h-4 flex items-center justify-center">
                <div #progressbar class="absolute top-0 bottom-0 left-0 rounded-lg bg-blue transition-all"></div>
            </div>
        </div>
        <div class="flex flex-col items-center align-center w-[40px]">
            <span class="text-xs font-bold whitespace-nowrap notranslate">Noch {{ initialTotal - total }}</span>
        </div>
    </ng-container>
    }

    @if(activeQuestion && (!evaluation || evaluation.length == 0)){
    <app-question slot="question" [orderSeed]="orderSeed" [question]="activeQuestion" [showFlag]="false"
        [flagged]="flagged" (questionFlagged)="handleQuestionFlagged()"
        (answersSelected)="handleAnswersSelected($event)" />
    } @else if(activeQuestion){
    <app-answer slot="question" [question]="activeQuestion" [evaluation]="evaluation" [showFlag]="false" [flagged]="flagged"
        [bookmarkInfo]="{responseId: currentResponseId}"></app-answer>
    } @else {
    <div class="container mx-auto max-w-screen-md text-center">
        <h2>Keine falschen Fragen übrig!</h2>
        <p>Du hast es geschafft - es sind keine Fragen mehr übrig, die du falsch beantwortet hast. Herzlichen
            Glückwunsch!</p>
    </div>
    }

    <ng-container slot="buttons">
        <a routerLink="/training"><button class="z-10 white-button">Beenden</button></a>
        <button class="z-10 white-button flex items-center gap-2 cursor-pointer" (click)="showQuestionsOverview()">
            <ng-icon name="faSolidList"></ng-icon>
            <span class="hidden sm:inline">Fragenübersicht</span>
        </button>
        @if(evaluation && evaluation.length > 0){
        <button class="z-10 blue-button" (click)="nextQuestion()">
            Nächste Frage
        </button>
        } @else if(currentAnswers && currentAnswers.length > 0) {
        <button class="z-10 blue-button" (click)="submitAnswer()">
            Weiter
        </button>
        } @else {
        <button class="z-10 disabled-button">
            Weiter
        </button>
        }
    </ng-container>
</app-test>

<app-modal #questionOverviewModal>
    <app-repeat-list (toggleModal)="toggleQuestionOverview()" [questions]="[]"
        (questionSelected)="nextQuestion($event)">
    </app-repeat-list>
</app-modal>